import React from 'react';
import EngineScoringHeaderCard from './EngineScoringHeaderCard';
import PropTypes from 'prop-types';

const EngineScoringHeaderContainer = ({
  isReadOnly,
  engineScoringId,
  containerDispatcher,
  header,
  loading,
  onChangeTitle,
  validation,
  onSave,
  canTestScoring,
  filterTypes,
  targetContexts,
  periodSelectionList,
  partnerBaseTypes,
  partnerTypes
}) => {
  return (
    <EngineScoringHeaderCard
      filterTypes={filterTypes}
      engineScoringId={engineScoringId}
      header={header}
      isReadOnly={isReadOnly}
      dispatch={containerDispatcher}
      targetContexts={targetContexts}
      periodSelectionList={periodSelectionList}
      partnerTypes={partnerTypes}
      onSave={onSave}
      loading={loading}
      validation={validation}
      onChangeTitle={onChangeTitle}
      partnerBaseTypes={partnerBaseTypes}
      canTestScoring={canTestScoring}
    />
  );
};

EngineScoringHeaderContainer.propTypes = {
  isReadOnly: PropTypes.bool,
  engineScoringId: PropTypes.number,
  containerDispatcher: PropTypes.func.isRequired,
  header: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onChangeTitle: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  canTestScoring: PropTypes.bool.isRequired,
  filterTypes: PropTypes.array.isRequired,
  targetContexts: PropTypes.array.isRequired,
  periodSelectionList: PropTypes.array.isRequired,
  partnerBaseTypes: PropTypes.array.isRequired,
  partnerTypes: PropTypes.array.isRequired
};

export default EngineScoringHeaderContainer;
